import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import Button from './Button';
import styles from './ModalShowPdf.module.scss';
import { generateFileUrl } from '../utils/fileUrl';

type ModalShowPdfProps = {
  title: string;
  pdfUrl: string;
  show: boolean;
  footerButtons?: React.ReactNode;
  handleClose: () => void;
};

const ModalShowPdf: React.FC<ModalShowPdfProps> = ({ title, pdfUrl, show, handleClose, footerButtons }) => {
  const [fileUrl, setFileUrl] = React.useState<string | null>(null);
  const [error, setError] = React.useState<string | null>(null);

  useEffect(() => {
    if (!show) return;

    let objectUrl: string | null = null;

    generateFileUrl(pdfUrl)
      .then((url) => {
        objectUrl = url;
        setFileUrl(url);
      })
      .catch((err) => {
        console.error('Erro ao carregar PDF:', err);
        setError(err.message);
      });

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      setFileUrl(null);
    };
  }, [pdfUrl, show]);
  
  return (
      <Modal show={show} onHide={handleClose} size="xl" centered>
        <Modal.Header closeButton className={styles['modal-pdf-header']}>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body className={styles['modal-pdf-body']}>
          {error ? (
            <div className={styles['error-message']}>{error}</div>
          ) : (
            <iframe
              src={fileUrl ?? ''}
              title={title}
              style={{ width: '100%', height: '100%' }}
              frameBorder={0}
            />
          )}
        </Modal.Body>
        <Modal.Footer className={styles['modal-pdf-footer']}>
          {footerButtons ? footerButtons : (
            <Button variant="secondary" onClick={handleClose} className={styles['btn-modal']}>
              Fechar
            </Button>
          )}
        </Modal.Footer>
      </Modal>
  );
};

export default ModalShowPdf;
